export default "__VITE_ASSET__DclyVsGV__"